import React from "react"
import { SlateNode } from "@convertkit/editor"

const EditorTimerImage = ({ slug, version }) => {
  return (
    <img
      src={`${process.env.NODE_FUNCTIONS_HOST}/countdown-timer?slug=${slug}&version=${version}`}
      alt=""
      width="800"
      height="150"
      style={{ display: "block", width: "100%", height: "auto" }}
    />
  )
}

export const TimerImage = ({ slug, url, version }) => {
  const sanitizeUrl = url => {
    if (url === undefined || url.length === 0) {
      return "#"
    }

    const protocol = /https?:\/\//
    if (url.match(protocol)) {
      return url
    }

    return `http://${url}`
  }

  return (
    <a href={sanitizeUrl(url)} rel="noopener noreferrer">
      <img
        src={`${process.env.NODE_FUNCTIONS_HOST}/countdown-timer?slug=${slug}&version=${version}`}
        alt=""
        style={{ display: "block", width: "100%" }}
      />
    </a>
  )
}

export const CountdownTimer = () => ({
  commands: {
    insertTimer: (editor, data) => {
      editor.insertBlock({
        type: "timer",
        data: data
      })
    }
  },
  schema: {
    blocks: {
      timer: { isVoid: true }
    }
  },
  renderNode(props, editor, next) {
    const { node, attributes } = props
    switch (node.type) {
      case "timer":
        return (
          <SlateNode {...attributes} node={node}>
            <EditorTimerImage
              slug={node.data.get("slug")}
              version={node.data.get("version")}
            />
          </SlateNode>
        )

      default:
        return next()
    }
  }
})
